import styled from 'styled-components';

export const StyledNavControl = styled.input`
    position: absolute;
    top: 10px;
    right: 10px;
    width: 42px;
    height: 42px;
    z-index: 3;
    appearance: none;

    &::after {
        content: '';
        position: absolute;
        top: 0;
        right: 0;
        display: block;
        width: 42px;
        height: 42px;
        background-image: url('assets/burger.svg');
        background-repeat: no-repeat;
        background-position: center;
        background-size: 17px;
    }

    &:checked::after {
        background-image: url('assets/cross.svg');
        background-size: 10px;
    }

    @media screen and (min-width: 577px) {
        & header {
            display: none;
        }
    }

    @media screen and (max-width: 576px) {
        &:checked + div .overlay {
            position: fixed;
            width: 100vw;
            height: 100vh;
            background-color: #00000099;
            z-index: 1;
        }

        &:checked + div nav {
            position: absolute;
            display: block;
        }
    }
`;
